var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelecommunicationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xlmnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508 508",
    style: {
      enableBackground: "new 0 0 508 508"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M56.8,414c46.4,57.6,117.6,94,197.2,94s150.8-36.8,197.2-94H56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M281.2,240.8L212,193.2h68c1.2,0,2-0.8,2.4-1.6c0.4-1.2,0-2-0.8-2.8l-75.6-52l-25.6-47.6 c-0.4-0.8-1.2-1.2-2-1.2s-1.6,0.4-2,1.2L150,136.8l-75.6,52c-0.8,0.4-1.2,1.6-0.8,2.8c0.4,1.2,1.2,1.6,2.4,1.6h68l-69.6,47.6 c-0.8,0.4-1.2,1.6-0.8,2.8c0.4,1.2,1.2,1.6,2.4,1.6h73.6v110l-34,47.2H96.4v12.4h164v-12.4H240l-32.8-46V245.2h73.6 c1.2,0,2-0.8,2.4-1.6C282.8,242.4,282.4,241.2,281.2,240.8z M201.2,400.4l-22-22.4l22.4-22.8c0,0.4,0,0.4,0,0.8v44.4H201.2z  M201.6,188.4l-22.4-23.2L202,142L201.6,188.4L201.6,188.4z M198.4,188.4h-42l20.8-21.2L198.4,188.4z M177.6,163.2l-22-22.4h43.6 L177.6,163.2z M175.6,165.2L154,187.6v-44.8L175.6,165.2z M200.4,193.2l-22.8,23.6l-22.8-23.6H200.4z M201.6,195.2v46.4l-22.8-23.2 L201.6,195.2z M154,302l22,22.4l-22,22.4V302z M154.4,296.8l23.2-23.6l23.2,23.6H154.4z M200.4,299.2l-23.2,23.6L154,299.2H200.4z  M177.6,326.4l23.2,23.6h-46.4L177.6,326.4z M200.4,352.4L177.2,376L154,352.4H200.4z M201.6,347.6l-22.8-23.2l22.8-23.2V347.6z  M179.2,271.2L202,248v46.4L179.2,271.2z M177.6,269.6L154.4,246h46L177.6,269.6z M200.4,243.6h-46l23.2-23.6L200.4,243.6z  M175.6,271.2L154,293.6v-44.4L175.6,271.2z M154,355.2l22,22.4L154,400V355.2z M155.6,401.6l22-22.4l22,22.4H155.6z M175.6,218.4 L154,240.8V196L175.6,218.4z M206.8,188.4v-45.2l65.6,45.2H206.8z M178.4,95.6l22,40.4h-44.8L178.4,95.6z M149.2,143.2v45.2H83.6 L149.2,143.2z M83.6,240.4l65.6-45.2v45.2H83.6z M149.2,362.8v39.6h-28.4L149.2,362.8z M234.4,402.4h-27.6V364L234.4,402.4z  M206.8,240.4v-45.2l65.6,45.2H206.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M345.2,263.2c-0.4,0-0.4,0-0.4-0.4c-0.4-0.4-0.4-0.8,0-1.2l35.6-36.4c0.4-0.4,0.8-0.4,1.2,0 c0.4,0.4,0.4,0.8,0,1.2L346,262.8C345.6,263.2,345.6,263.2,345.2,263.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M380.8,263.2c-0.4,0-0.4,0-0.4-0.4l-35.6-36.4c-0.4-0.4-0.4-0.8,0-1.2s0.8-0.4,1.2,0l35.6,36.4 c0.4,0.4,0.4,0.8,0,1.2C381.2,263.2,380.8,263.2,380.8,263.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M380.8,263.2h-35.6c-0.4,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h35.6c0.4,0,0.8,0.4,0.8,0.8 C381.6,262.8,381.2,263.2,380.8,263.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M380.8,226.8h-35.6c-0.4,0-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8h35.6c0.4,0,0.8,0.4,0.8,0.8 C381.6,226.4,381.2,226.8,380.8,226.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M345.2,299.6c-0.4,0-0.4,0-0.4-0.4c-0.4-0.4-0.4-0.8,0-1.2l35.6-36.4c0.4-0.4,0.8-0.4,1.2,0 c0.4,0.4,0.4,0.8,0,1.2L346,299.2C345.6,299.2,345.6,299.6,345.2,299.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M380.8,299.6c-0.4,0-0.4,0-0.4-0.4l-35.6-36.4c-0.4-0.4-0.4-0.8,0-1.2c0.4-0.4,0.8-0.4,1.2,0 l35.6,36.4c0.4,0.4,0.4,0.8,0,1.2C381.2,299.2,380.8,299.6,380.8,299.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M380.8,299.6h-35.6c-0.4,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h35.6c0.4,0,0.8,0.4,0.8,0.8 C381.6,299.2,381.2,299.6,380.8,299.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.2,
    y: 260,
    style: {
      fill: "#ACB3BA"
    },
    width: 35.6,
    height: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M345.2,335.6c-0.4,0-0.4,0-0.4-0.4c-0.4-0.4-0.4-0.8,0-1.2l35.6-36.4c0.4-0.4,0.8-0.4,1.2,0 c0.4,0.4,0.4,0.8,0,1.2L346,335.6C345.6,335.6,345.6,335.6,345.2,335.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M380.8,335.6c-0.4,0-0.4,0-0.4-0.4l-35.6-36.4c-0.4-0.4-0.4-0.8,0-1.2c0.4-0.4,0.8-0.4,1.2,0 l35.6,36.4c0.4,0.4,0.4,0.8,0,1.2C381.2,335.6,380.8,335.6,380.8,335.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    style: {
      fill: "#ACB3BA"
    },
    d: "M380.8,335.6h-35.6c-0.4,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h35.6 c0.4,0,0.8,0.4,0.8,0.8C381.6,335.2,381.2,335.6,380.8,335.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M380.8,299.6h-35.6c-0.4,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h35.6c0.4,0,0.8,0.4,0.8,0.8 C381.6,299.2,381.2,299.6,380.8,299.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M345.2,372c-0.4,0-0.4,0-0.4-0.4c-0.4-0.4-0.4-0.8,0-1.2l35.6-36.4c0.4-0.4,0.8-0.4,1.2,0 c0.4,0.4,0.4,0.8,0,1.2L346,372C345.6,372,345.6,372,345.2,372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M380.8,372c-0.4,0-0.4,0-0.4-0.4l-35.6-36.4c-0.4-0.4-0.4-0.8,0-1.2c0.4-0.4,0.8-0.4,1.2,0 l35.6,36.4c0.4,0.4,0.4,0.8,0,1.2C381.2,372,380.8,372,380.8,372z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_1",
    style: {
      fill: "#ACB3BA"
    },
    d: "M380.8,372h-35.6c-0.4,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h35.6 c0.4,0,0.8,0.4,0.8,0.8C381.6,371.6,381.2,372,380.8,372z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    style: {
      fill: "#ACB3BA"
    },
    d: "M380.8,335.6h-35.6c-0.4,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h35.6 c0.4,0,0.8,0.4,0.8,0.8C381.6,335.2,381.2,335.6,380.8,335.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M345.2,408.4c-0.4,0-0.4,0-0.4-0.4c-0.4-0.4-0.4-0.8,0-1.2l35.6-36.4c0.4-0.4,0.8-0.4,1.2,0 c0.4,0.4,0.4,0.8,0,1.2L346,408C345.6,408.4,345.6,408.4,345.2,408.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M380.8,408.4c-0.4,0-0.4,0-0.4-0.4l-35.6-36.4c-0.4-0.4-0.4-0.8,0-1.2c0.4-0.4,0.8-0.4,1.2,0 l35.6,36.4c0.4,0.4,0.4,0.8,0,1.2C381.2,408.4,380.8,408.4,380.8,408.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M380.8,408.4h-35.6c-0.4,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h35.6c0.4,0,0.8,0.4,0.8,0.8 C381.6,408,381.2,408.4,380.8,408.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_1_1_",
    style: {
      fill: "#ACB3BA"
    },
    d: "M380.8,372h-35.6c-0.4,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h35.6 c0.4,0,0.8,0.4,0.8,0.8C381.6,371.6,381.2,372,380.8,372z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M381.2,409.2h-36c-0.8,0-1.6-0.8-1.6-1.6V226c0-0.8,0.8-1.6,1.6-1.6h36c0.8,0,1.6,0.8,1.6,1.6v181.6 C382.8,408.4,382,409.2,381.2,409.2z M346.8,406h32.8V227.6h-32.8V406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M381.2,227.6h-36c-0.4,0-1.2-0.4-1.6-0.8c-0.4-0.4-0.4-1.2,0-1.6l18.4-32.8c0.4-0.4,0.8-0.8,1.6-0.8 c0.8,0,1.2,0.4,1.6,0.8l17.6,32.8c0.4,0.4,0.4,1.2,0,1.6C382.4,227.2,382,227.6,381.2,227.6z M348,224.4h30.4l-14.8-27.6L348,224.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M406.4,411.6h-25.6c-0.8,0-1.6-0.8-1.6-1.6v-36c0-0.8,0.4-1.2,1.2-1.6c0.8,0,1.2,0,1.6,0.4l25.6,36 c0.4,0.4,0.4,1.2,0,1.6C407.6,411.6,406.8,411.6,406.4,411.6z M382,408.8h21.2L382,379.2V408.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M433.2,263.2h-52c-0.8,0-1.6-0.8-1.6-1.6V226c0-0.8,0.4-1.2,0.8-1.6c0.4-0.4,1.2-0.4,1.6,0l52,35.6 c0.4,0.4,0.8,1.2,0.8,2C434.4,262.8,434,263.2,433.2,263.2z M382.8,260h44.8l-44.8-30.8V260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M345.2,263.2h-52c-0.8,0-1.2-0.4-1.6-1.2c-0.4-0.8,0-1.6,0.8-2l52-35.6c0.4-0.4,1.2-0.4,1.6,0 s0.8,0.8,0.8,1.6v35.6C346.8,262.4,346,263.2,345.2,263.2z M298.8,260h44.8v-30.8L298.8,260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M433.2,298.8h-52c-0.8,0-1.6-0.8-1.6-1.6v-35.6c0-0.8,0.4-1.2,0.8-1.6s1.2-0.4,1.6,0l52,35.6 c0.4,0.4,0.8,1.2,0.8,2C434.4,298.4,434,298.8,433.2,298.8z M382.8,295.6h44.8l-44.8-30.8V295.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M345.2,298.8h-52c-0.8,0-1.2-0.4-1.6-1.2c-0.4-0.8,0-1.6,0.8-2l52-35.6c0.4-0.4,1.2-0.4,1.6,0 s0.8,0.8,0.8,1.6v35.6C346.8,298,346,298.8,345.2,298.8z M298.8,295.6h44.8v-30.8L298.8,295.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M345.2,411.6h-25.6c-0.4,0-1.2-0.4-1.2-0.8c-0.4-0.4-0.4-1.2,0-1.6l25.6-36c0.4-0.4,1.2-0.8,1.6-0.4 c0.8,0,1.2,0.8,1.2,1.6v36C346.8,411.2,346,411.6,345.2,411.6z M322.4,408.8h21.2v-29.6L322.4,408.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.2,
    y: 406.4,
    style: {
      fill: "#ACB3BA"
    },
    width: 112,
    height: 8.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelecommunicationIcon);
export default __webpack_public_path__ + "static/media/telecommunication_icon.c932e948515afcd70fa1250fd53d5ebb.svg";
export { ForwardRef as ReactComponent };